import React, { useState } from 'react';

import TableWithSummary from '../../../../../components/table/TableWithSummary';
import Button from '../../../../../components/Button';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ACCOUNT_USER_COUPON_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/accountUserConstants';
import { columns } from './columns';
import { useAccountUserCouponDetail, useCheckValidGenerateCoupon } from './hooks';
import { ACCOUNT_USER_DETAIL_COUPON_HISTORY_LIST_FILTER_OPTION_MODEL } from './models';
import GenerateCouponUserDetailModal from './GenerateCouponUserDetailModal';
import GenerateCouponValidSuccessModal from './GenerateCouponValidSuccessModal';
import GenerateCouponValidFailModal from './GenerateCouponValidFailModal';

import Can from '../../../../../components/common/Can';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../constants/service/common/userPermissions';

import './AccountUserDetailCouponInfo.scss';

const AccountUserDetailCouponInfo = (props) => {
  const { userId, isActive } = props;

  const [isGenerateCouponModalOpen, setIsGenerateCouponModalOpen] = useState(false);
  const { couponHistoryList, pagination, filterOption, setPagination, setFilterOption } = useAccountUserCouponDetail({
    userId,
    isActive,
  });

  const { checkValidGenerateCoupon, validResult, resetValidResult } = useCheckValidGenerateCoupon({ userId });

  const getCouponList = (data) => {
    const { filterOption, pagination } = data;
    setPagination(pagination);
    setFilterOption(filterOption);
  };

  const validateGenerationCouponHanlder = (selectedCouponInfoList) => checkValidGenerateCoupon(selectedCouponInfoList);

  //쿠폰 발급 모달 띄우기
  const generateCouponHandler = () => setIsGenerateCouponModalOpen(true);

  //쿠폰 발급 모달 닫기
  const closeGenerateCouponModalHandler = () => setIsGenerateCouponModalOpen(false);

  return (
    <div className="account-user-detail-content">
      {/* 쿠폰 내역 리스트*/}
      <div className="account-user-detail-section">
        <div className="title">쿠폰 내역 리스트</div>

        <Can I={PERMISSION_ACTIONS.CREATE} a={PERMISSION_SUBJECTS.COUPON}>
          <div className="coupon-generate">
            <Button color="primary" isRadius text="쿠폰 발급하기" onClick={generateCouponHandler} />
          </div>
        </Can>

        <div className="account-user-detail-section-content">
          <TableWithSummary
            className="account-user-detail-section-list"
            data={couponHistoryList.list}
            totalCnt={couponHistoryList.totalCnt}
            isStriped={true}
            emptyText={ACCOUNT_USER_COUPON_LIST_TABLE_EMPTY_TEXT}
            showPagination
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_COUPON_HISTORY_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            filterOption={filterOption}
            pagination={pagination}
            getList={getCouponList}
            maxHeight={1200}
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
          />
        </div>
      </div>
      {isGenerateCouponModalOpen && (
        <GenerateCouponUserDetailModal
          userId={userId}
          closeModal={closeGenerateCouponModalHandler}
          onValidateGenerateCoupon={validateGenerationCouponHanlder}
        />
      )}
      {validResult.impossibleCnt === 0 && (
        <GenerateCouponValidSuccessModal closeModal={resetValidResult} validResult={validResult} />
      )}
      {validResult.impossibleCnt > 0 && (
        <GenerateCouponValidFailModal closeModal={resetValidResult} validResult={validResult} />
      )}
    </div>
  );
};

export default AccountUserDetailCouponInfo;
